import { useCallback } from "react";
import axios from "@api/axiosPrivate";
import { setNewAccessToken, expireSession } from "@store/userReducer";
import { useDispatch } from "react-redux";

// All hook instances share one exchange: refresh cookies rotate on the server.
let refreshPromise = null;
const useRefreshToken = () => {
  const dispatch = useDispatch();
  return useCallback(() => {
    if (!refreshPromise) {
      refreshPromise = (async () => {
        try {
          let response;
          for (let attempt = 0; ; attempt++) {
            try {
              response = await axios.get("/auth/refresh", {
                withCredentials: true,
              });
              break;
            } catch (error) {
              if (error.response || attempt >= 2) throw error;
              await new Promise((resolve) =>
                setTimeout(resolve, 1000 * (attempt + 1)),
              );
            }
          }
          if (!response.data?.access_token)
            throw new Error("Missing access token");
          dispatch(
            setNewAccessToken({ access_token: response.data.access_token }),
          );
          return response.data.access_token;
        } catch (error) {
          if ([401, 403].includes(error?.response?.status))
            dispatch(expireSession());
          throw error;
        }
      })().finally(() => {
        refreshPromise = null;
      });
    }
    return refreshPromise;
  }, [dispatch]);
};
export { useRefreshToken };
